<template>
  <div class="resend-qr-code-page">
    <img src="../assets/face logo.png">

    <div class="title">
      Face Club COVID-19 Tracking
    </div>

    <form class="fc-form">
      <div class="fc-form-row">
        <vi-phone-number
          :number="phoneData"
          :prefix="phonePrefixData"
          @input="onPhoneNumberInput"
        />
        <span v-if="$v.phone.$error" class="form-error">Mobile Nummer ist erforderlich</span>
        <span v-else-if="serverError" class="form-error">{{serverError}}</span>
      </div>
      <button
        class="fc-button"
        :disabled="!phoneData"
        @click.prevent="reSendQRCode">RE Send
      </button>
    </form>

    <div class="notifications-container">
      <notifications group="re-send-code" />
    </div>
  </div>
</template>

<script>
  import { reSendQRCode } from "../services/graphql";
  import { required } from "vuelidate/lib/validators";
  import ViPhoneNumber from "../components/ViPhoneNumber";

  export default {
    name: "ReSendQRCodePage",
    components: {ViPhoneNumber},

    data() {
      return {
        phone: null,
        phoneData: null,
        phonePrefixData: null,
        serverError: null
      };
    },

    validations: {
      phone: {
        required
      }
    },

    methods: {
      reSendQRCode() {
        this.serverError = null;
        this.$v.phone.$touch();
        if (this.$v.$invalid) {
          return false;
        }

        reSendQRCode(this.phone.trim())
          .then(response => {
            this.serverError = null;

            this.$notify({
                group: 're-send-code',
                title: 'QR-Code erfolgreich gesendet',
                duration: 6000
            });
          })
          .catch(err => {
            if (
              err.graphQLErrors &&
              err.graphQLErrors.length
            ) {
              if (err.graphQLErrors[0].message === "User not found") {
                this.$emit("userNotExist", this.phone);
                this.serverError = err.graphQLErrors[0].message;
              } 
              else if (err.graphQLErrors[0].message) {
                this.$v.$reset();
                this.serverError = err.graphQLErrors[0].message;
              }
            }
          });
      },

      onPhoneNumberInput({prefix, number}) {
        this.serverError = null;
        this.phone = `${prefix}${number}`;
        this.phoneData = number;
        this.phonePrefixData = prefix;
      }
    },

    created() {
      
    }
  };
</script>

<style lang="scss">
  @import "ReSendQRCodePage";
</style>
